<template>
  <base-section
  id="program"
  >
    <v-container>
    <base-section-heading
    title="Program"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
You can find the technical program in pdf version <a href="LATS2024_Technical_Program_9April.pdf" download>here</a>.
Please check out the news about <a href="program/keynotes">Keynotes</a>, <a href="program/visionary">Visionary</a>, <a href="program/invited">Invited talks</a> and <a href="program/tutorials">Tutorials</a>.
<br><br>
<v-btn
        href="LATS2024_Technical_Program_9April.pdf"
        rounded
        color="primary"
        dark
        download
        style="padding: 15px"
    >
        <v-icon
        left
        dark
        >
        mdi-download
        </v-icon>
        Technical Program
        </v-btn>
</strong>
<br><br><br>
<div
v-for="day in days"
:key="day.title"
>
<h1><strong><span style="color: #068aa2">{{ day.title }}</span></strong></h1>
<br>
<div
v-for="session, i in day.sessions"
:key="i"
>
  <div v-if="session.to">
    <h2>{{session.hours}} {{session.title}}
      (details
      <a :href="session.to">
      here</a>)
    </h2>
  </div>
  <div
  v-else
  >
  <h2>{{session.hours}} {{session.title}}</h2>
  </div>
  <div v-if="session.timeslots">
    <i>{{session.timeslots}}</i>
  </div>
<h3>{{session.optionalTitle}}</h3>
<div v-html="session.authors" />
<div
v-if="session.htmlText"
>
<div v-html="session.htmlText" />
</div>
<div
v-if="session.chair"
>
Session Chair: <i>{{session.chair}}</i>
<br>
</div>
<div
v-if="session.organizer"
>
<h3>Organized by {{session.organizer}}</h3>
<br>
</div>
<div
v-if="session.moderator"
>
<h3>Organized and moderated by {{session.moderator}}</h3>
<br>
</div>
<div
v-if="session.panelists"
>
<h3>Panelists: {{session.panelists}}</h3>
<br>
</div>
<br>
<div
v-if="session.posters"
>
<br>
<h2>Short Papers:</h2>
<div
v-for="talk in session.posters"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<div
v-if="session.case"
>
<h2>Case studies:</h2>
<div
v-for="talk in session.case"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<div
v-if="session.late"
>
<h2>Late Contributions:</h2>
<div
v-for="talk in session.late"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<div
v-else
>
<div
v-for="talk in session.talks"
:key="talk.title"
>
<h4><strong>{{talk.title}}</strong></h4>
<h4><div v-html="talk.authors" /></h4>
<br>
</div>
</div>
<br>
</div>
</div>
</base-section-heading>

    </v-container>
  </base-section>
</template>

<script>
import EnhancedProfileCard from "@/components/base/EnhancedProfileCard.vue"

export default {
    name: 'Program',
    components: {
      EnhancedProfileCard,
    },
    data: () => ({
      days: [
        {
          title: "Tuesday April 9th, 2024 (Student Activities)",
          sessions: [
            {
              hours: "09:30 - 10:45",
              title: "Tutorial 1 - Part 1",
              optionalTitle: "Test and Health Monitoring under Approximations and Variations",
              authors: 'Hans-Joachim Wunderlich, University of Stuttgart, Germany',
              to: "program/tutorials",
            },
            {
              hours: "10:45 - 11:15",
              title: "Coffee Break",
            },
            {
              hours: "11:15 - 12:30",
              title: "Tutorial 1 - Part 2",
              optionalTitle: "Test and Health Monitoring under Approximations and Variations",
              authors: 'Hans-Joachim Wunderlich, University of Stuttgart, Germany',
              to: "program/tutorials",
            },
            {
              hours: "12:30 - 14:00",
              title: "Lunch",
              authors: "This lunch is not included in the registration fee, except for the tutorial speakers & organizing committee",
            },
            {
              hours: "14:00 - 15:30",
              title: "Tutorial 2",
              optionalTitle: "Design Methods and Tools for Future-Generation Secure Computer Architectures",
              authors: "Farhad Merchant, Newcastle University, UK",
              to: "program/tutorials",
            },
            {
              hours: "15:30 - 16:00",
              title: "Coffee Break",
            },
            {
              hours: "16:00 - 17:30",
              title: "Tutorial 3",
              optionalTitle: "Silicon Lifecycle Management",
              authors: "Yervant Zorian, Synopsys, US",
              to: "program/tutorials",
            },
          ],
        },
        {
          title: "Wednesday April 10th, 2024",
          sessions: [
            {
              hours: "07:30 - 08:30",
              title: "Registration",
            },
            {
              hours: "08:30 - 09:00",
              title: "LATS2024 Opening Session",
              htmlText: "LATS2024 General Co-Chairs: <br> &nbsp;&nbsp;&nbsp;&nbsp;Leticia Bolzani Pöhls - RWTH Aachen, (Germany)<br>&nbsp;&nbsp;&nbsp;&nbsp;Yervant Zorian, Synopsys (USA)<br>Vice General Chair:<br>&nbsp;&nbsp;&nbsp;&nbsp;Tiago Balen - UFRGS, (Brazil)<br>LATS2024 Program Co-Chairs:<br>&nbsp;&nbsp;&nbsp;&nbsp;Ernesto Sanchez, Politecnico di Torino (Italy)<br>&nbsp;&nbsp;&nbsp;&nbsp;Marcelo Lubaszewski - UFRGS, (Brazil)<br>Vice Program Chair:<br>&nbsp;&nbsp;&nbsp;&nbsp;Cristina Meinhardt - UFSC, (Brazil)",
            },
            {
              hours: "09:00 - 09:45",
              title: "Opening Keynote",
              optionalTitle: "LATS and the test of ICs: a brief summary of the last 25 years and some thoughts about the future",
              authors: "Matteo Sonza Reorda, Politecnico di Torino, Italy",
              chair: "Yervant Zorian, Synopsys, USA",
              to: "program/keynotes",
            },
            {
              hours: "09:45 - 10:30",
              title: "Session 1 \"Reliability Assessment using Fault Injection\"",
              timeslots: "(Paper time slot of 15 minutes: 12 minutes  + 3 minutes  Q&A)",
              chair: "Tiago Balen, UFRGS, Brazil",
              talks: [
                {
                  title: "A Micro Architectural Events Aware Real-Time Embedded System Fault Injector",
                  authors: "<b>Enrico Magliano</b>, Alessio Carpegna, Alessandro Savino and Stefano Di Carlo\
                <br> <i>Politecnico di Torino, Italy</i>",
                },
                {
                  title: "Space Radiation Flux Driven Fault Injection for Evaluating Dynamic Mitigation Strategies",
                  authors: "Junchao Chen<sup>1</sup>, Li Lu<sup>1</sup>, <b>Marko Andjelkovic</b><sup>1</sup>, Fabian Luis Vargas<sup>1</sup> and Milos Krstic<sup>1,2</sup>\
                  <br> <i><sup>1</sup>IHP GmbH, Germany and <sup>2</sup>University of Potsdam, Germany</i>",
                },
                {
                  title: "Reliability Assessment of Arm Cortex-M Processors under Heavy Ions and Emulated Fault Injection",
                  authors: "Leonardo Reinehr Gobatto<sup>1</sup>, Fabio Benevenuti<sup>1</sup>, Nemitala Added<sup>2</sup>, Saulo G. Alberton<sup>2</sup>, Eduardo L. A. Macchione<sup>2</sup>, Vitor A. P. Aguiar<sup>2</sup>, Nilberto H. Medina<sup>2</sup>, <b>Fernanda L. Kastensmidt</b><sup>1</sup> and José Rodrigo Azambuja<sup>1</sup>\
                  <br> <i><sup>1</sup>UFRGS, Brazil and <sup>2</sup>USP, Brazil</i>",
                },
              ],
            },
            {
              hours: "10:30 - 11:00",
              title: "Coffee-break",
            },
            {
              hours: "11:00 - 11:45",
              title: "Keynote Talk",
              to: "program/keynotes",
              optionalTitle: "Chip technology and computing: the need of new mind set to sustain the future",
              authors: "Said Hamdioui, Delft University of Technology, The Netherlands",
              chair: "Matteo Sonza Reorda, Politecnico di Torino, Italy",
            },
            {
              hours: "11:45 - 12:30",
              title: "Session 2 \"Beyond Testing\"",
              timeslots: "(Paper time slot of 15 minutes: 12 minutes  + 3 minutes  Q&A)",
              chair: "Maksim Jenihhin, Tallinn University of Technology, Estonia",
              talks: [
                {
                  title: "A Verification Platform for Human Pose Estimation Models",
                  authors: "Stefano Aldegheri, Michele Boldo, Mirco De Marchi, Roberto Di Marco, Enrico Martini and <b>Nicola Bombieri</b>\
                  <br> <i>University of Verona, Italy</i>",
                },
                {
                  title: "Data-Oblivious and Performant: On Designing Security-Conscious Hardware",
                  authors: "<b>Lucas Deutschmann</b><sup>1</sup>, Yazan Kazhalawi<sup>1</sup>, Jonathan Seckinger<sup>1</sup>, Anna Lena Duque Antón<sup>1</sup>, Johannes Müller<sup>1</sup>, Mohammad Rahmani Fadiheh<sup>2</sup>, Dominik Stoffel<sup>1</sup> and Wolfgang Kunz<sup>1</sup>\
                  <br> <i><sup>1</sup>University of Kaiserlautern-Landau, Germany and <sup>2</sup>Stanford University, USA</i>",
                },
                {
                  title: "Aging and Soft Error Resilience in Reconfigurable CNN Accelerators Employing a Multi-Purpose On-Chip Sensor",
                  authors: "<b>Rizwan Tariq Syed</b><sup>1</sup>, Fabian Luis Vargas<sup>1</sup>, Marko Andjelkovic<sup>1</sup>, Markus Ulbricht<sup>1</sup> and Milos Krstic<sup>1,2</sup>\
                  <br> <i>IHP GmbH, Germany and <sup>2</sup>University of Potsdam, Germany</i>",
                },
              ],
            },
            {
              hours: "12:30 - 14:00",
              title: "Lunch",
            },
            {
              hours: "14:00 - 14:30",
              title: "Invited Talk",
              optionalTitle: "Testing of Smart Production Lines",
              authors: "Franco Fummi, University of Verona, Italy",
              chair: "Marcelo Lubaszewski, UFRGS, Brazil",
            },
            {
              hours: "14:30 - 15:30",
              title: "Session 3 \"RRAM Testing\"",
              timeslots: "(Paper time slot of 15 minutes: 12 minutes  + 3 minutes  Q&A)",
              chair: "Victor Champac, INAOE, Mexico",
              talks: [
                {
                  title: "Cycle-Accurate FPGA Emulation of RRAM Crossbar Array: Efficient Device and Variability Modeling with Energy Consumption Assessment",
                  authors: "<b>Jianan Wen</b><sup>1</sup>, Fabian Luis Vargas<sup>1</sup>, Fukun Zhu<sup>1</sup>, Daniel Reiser<sup>3</sup>, Andrea Baroni<sup>1</sup>, Markus Fritscher<sup>1,4</sup>, Eduardo Perez<sup>1,4</sup>, Marc Reichenbach<sup>3</sup>, Christian Wenger<sup>1,4</sup> and Milos Krstic<sup>1,2</sup>\
                  <br> <i><sup>1</sup>IHP GmbH, Germany, <sup>2</sup>University of Potsdam, Germany, <sup>3</sup>University of Rostock, Germany and <sup>4</sup>Brandenburg University of Technology Cottbus-Senftenberg, Germany</i>",
                },
                {
                  title: "Analysis of Conductance Variability in RRAM for Accurate Neuromorphic Computing",
                  authors: "<b>Hassen Aziza</b><sup>1</sup>, Jeremy Postel-Pellerin<sup>1</sup>, Moritz Fieback<sup>2</sup>, Said Hamdioui<sup>2</sup>, Hanzhi Xun<sup>2</sup>, Mottaqiallah Taouil<sup>2</sup>, Karine Coulié<sup>1</sup> and Wenceslas Rahajandraibe<sup>1</sup>\
                  <br><i><sup>1</sup>IM2NP - Aix-Marseille University, France and <sup>2</sup>Delft University of Technology, Netherlands</i>",
                },
                {
                  title: "Analysing the Use of Temperature to Facilitate Fault Propagation in ReRAMs",
                  authors: "<b>Thiago Santos Copetti</b><sup>1</sup>, Aksh Chordia<sup>1</sup>, Moritz Fieback<sup>2</sup>, Mottaqiallah Taouil<sup>2</sup>, Said Hamdioui<sup>2</sup> and Letícia Maria Bolzani Poehls<sup>1</sup>\
                  <br><i><sup>1</sup>RWTH Aachen University, Germany and <sup>2</sup>Delft University of Technology, Netherlands</i>",
                },
                {
                  title: "A Fully Automated Platform for Evaluating ReRAM Crossbars",
                  authors: "<b>Rebecca Pelke</b>, Felix Staudigl, Niklas Thomas, Nils Bosbach, Mohammed Hossein, José Cubero-Cascante, Leticia Bolzani Pöhls, Rainer Leupers and Jan Moritz Joseph\
                  <br><i>RWTH Aachen University, Germany</i>",
                },
              ],
            },
            {
              hours: "15:30 - 16:00",
              title: "Coffee-break",
            },
            {
              hours: "16:00 - 16:30",
              title: "Invited Talk",
              optionalTitle: "Challenges for design and test of cryogenic analog RF MOSFET circuits for spin quantum bit control and readout",
              authors: "Salvador Mir, Research Director, CNRS/Université Grenoble Alpes/TIMA - France",
              chair: "Florence Azais, LIRM, CNRS University of Montpellier, France",
              to: "program/invited",
            },
            {
              hours: "16:30 - 17:30",
              title: "Special Session 1",
              timeslots: "(Paper time slot of 20 minutes: 15 minutes  + 5 minutes  Q&A)",
              organizer: "Marie Lise Flottes, LIRMM, France",
              talks: [
                {
                  title: "CAC 2.0: A Corrupt and Correct Logic Locking Technique Resilient to Structural Analysis Attacks",
                  authors: "<b>Levent Aksoy</b><sup>1</sup>, Muhammad Yasin<sup>3</sup> and Samuel Pagliarini<sup>1,2</sup>\
                  <br> <i><sup>1</sup>Tallin University of Technology, Estonia, <sup>2</sup>Carnegie Mellon University, USA and <sup>3</sup>National University of Sciences and Technology, Pakistan</i>",
                },
                {
                  title: "Logic Locking: Exploration of a new key-gate based on tristate logic",
                  authors: "<b>Sophie Dupuis</b>, Nassim Riadi, Clémy Moroukian, Florence Azais and Marie-Lise Flottes\
                  <br><i>LIRMM, UM, CNRS, France</i>",
                },
                {
                  title: "Internal State Monitoring in RISC-V Microarchitectures for Security Purpose",
                  authors: "<b>Roua Boulifa</b>, Giorgio Di Natale and Paolo Maistri\
                  <br><i>TIMA, France</i>",
                },
              ],
            },
            {
              hours: "17:30 - 18:30",
              title: "Panel about Silent Data Corruption",
              moderator: "Yervant Zorian, Synopsys, USA",
              panelists: "Shawn Blanton, Kaushik Roy, and Hans-Joachim Wunderlich",
            },
            {
              hours: "19:30 - 22:30",
              title: "Welcome Cocktail",
            },
          ],
        },
        {
          title: "Thursday April 11th, 2024",
          sessions: [
            {
              hours: "08:30 - 09:15",
              title: "Visionary Talk",
              to: "program/visionary",
              optionalTitle: "Cognitive Computing: Design, Verification & Security Challenges",
              authors: "Kaushik Roy, Purdue University, USA",
              chair: "Sybille Hellebrand, University of Paderborn, Germany",
            },
            {
              hours: "09:15 - 10:15",
              title: "Poster Session",
              timeslots: "(Paper time slot of 5 minutes + Poster)",
              chair: "Cristina Meinhardt, UFSC, Brazil",
              posters: [
                {
                  title: "An integrated environment for the reliability assessment of CNNs implemented in FPGAs",
                  authors: "<b>Luis-Ariel Mesa-Mesa</b><sup>2</sup>, Erika-Dajanna Castañeda-Monroy<sup>2</sup>, Juan-David Guerrero-Balaguera<sup>1</sup>, Ernesto Sanchez-Sanchez<sup>1</sup> and Wilson-Javier Perez-Holguin<sup>2</sup>\
                  <br><i><sup>1</sup>Politecnico di Torino, Italy and <sup>2</sup>Universidad Pedagógica y Tecnológica de Colombia, Colombia</i>",
                },
                {
                  title: "Analysis of Thermal Side-Channel Attacks on Analog/Digital Computing-in-Memory Accelerators",
                  authors: "<b>Lorenzo Pfeifer</b>, Michael Gross, Felix Staudigl, Rainer Leupers and Jan Moritz Joseph\
                  <br> <i>RWTH Aachen University, Germany</i>",
                },
                {
                  title: "Exploiting Static Power Consumption in Side-Channel Analysis",
                  authors: "<b>Levgen Kabin</b>, Peter Langendoerfer and Zoya Dyka\
                  <br> <i>IHP GmbH, Germany</i>",
                },
                {
                  title: "Analyzing the Reliability of Stream Sparse Matrix-Vector Multiplication Accelerators: A High-Level Approach",
                  authors: "María Luisa Pinto-Salamanca<sup>1</sup>, Josie Esteban Rodriguez Condia<sup>2</sup>, Jose A. Hidalgo-Lopez<sup>3</sup> and <b>Wilson Javier Perez-Holguín</b><sup>1</sup>\
                  <br> <i><sup>1</sup>Universidad Pedagógica y Tecnológica de Colombia, Colombia, <sup>2</sup>Politecnico di Torino, Italy and <sup>3</sup>Universidad de Málaga, Spain</i>",
                },
                {
                  title: "Exploring trade-offs in multi-site wafer testing",
                  authors: "Tommaso Foscale, Lorenzo Cardone and <b>Paolo Bernardi</b>\
                  <br> <i>Politecnico di Torino, Italy</i>",
                },
                {
                  title: "Optimizing WLAN ATE Production Testing: Rx PER Methodology over Rx EVM",
                  authors: "Jeyendran Nithyanadam<sup>1</sup>, Alban Haynse Immanuel<sup>1</sup> and Khoushikh S.<sup>2</sup>\
                  <br> <i><sup>1</sup>Infineon Technologies, India and <sup>2</sup>Infineon Technologies, USA</i>",
                },
              ],
              case: [
                {
                  title: "Automated UPS Testing System for Final Test Applications in Industrial Environments",
                  authors: "<b>Acacio Costa</b> and Jarbas Silveira\
                  <br><i>UFC, Brazil</i>",
                },
              ],
              late: [
                {
                  title: "Analog Fault Simulation: Trends and Perspectives in Analog Hardware Description Languages",
                  authors: "Nicola Dall'Ora<sup>1</sup>, <b>Enrico Fraccaroli</b><sup>1</sup>, Renaud Gillon<sup>2</sup> and Franco Fummi<sup>1</sup>\
                  <br><i><sup>1</sup>University of Verona, Italy and <sup>2</sup>Sydelity b.v., Belgium</i>",
                },
                {
                  title: "Secured Bus as a Countermeasure against Covert Channels: NEORV32 Case Study",
                  authors: "Régis Leveugle<sup>1</sup>, Nathan Hocquette<sup>1</sup>, Charles Labarre<sup>1</sup>, Romain Plumaugat<sup>1</sup>, Loic Tcharoukian<sup>1</sup>, Valentin Martinoli<sup>2</sup> and Yannick Teglia<sup>2</sup>\
                  <br><i><sup>1</sup>Grenoble INP - UGA, France and <sup>2</sup>Thales DIS, France</i>",
                },
                {
                  title: "Study of a Spintronic-based STDP-trained SNN under Fabrication-induced Process Variability",
                  authors: "<b>Elena Ioana Vatajelu</b> and Salah Daddinounou\
                  <br> <i>TIMA, France</i>",
                },
              ],
            },
            {
              hours: "10:15 - 10:30",
              title: "Coffee-break",
            },
            /*
            {
              hours: "10:30 - 11:15",
              title: "Visionary Talk",
              to: "program/visionary",
              optionalTitle: "A Cambrian Explosion in Electronic System Testing is Dead Ahead (TBC)",
              authors: "Subhasish Mitra, Stanford University, USA",
            },
            */
            {
              hours: "10:30 - 11:15",
              title: "Session 4 \"Analog and Low Voltage Testing\"",
              timeslots: "(Paper time slot of 15 minutes: 12 minutes  + 3 minutes  Q&A)",
              chair: "Fernanda Kastensmidt, UFRGS, Brazil",
              talks: [
                {
                  title: "Digital generation of single tone FM/PM test stimuli: a theoretical analysis",
                  authors: "<b>Kamilia Tahraoui</b><sup>1</sup>, Florence Azais<sup>1</sup>, Laurent Latorre<sup>1</sup>, François Lefèvre<sup>2</sup> and Thibault Vayssade<sup>1</sup>\
                  <br><i><sup>1</sup>LIRMM, University of Montpellier, CNRS, France and <sup>2</sup>NXP Semiconductors, France</i>",
                },
                {
                  title: "Vmin Testing under Variations: Defect versus Fault Coverage",
                  authors: "<b>Hanieh Jafarzadeh</b><sup>1</sup>, Florian Klemme<sup>1</sup>, Hussam Amrouch<sup>3</sup>, Sybille Hellebrand<sup>2</sup> and Hans-Joachim Wunderlich<sup>1</sup>\
                  <br><i><sup>1</sup>University of Stuttgart, Germany, <sup>2</sup>Paderborn University, Germany and <sup>3</sup>TUM, Germany</i>",
                },
                {
                  title: "Behavioral and Variability Analysis for Enclosed Layout Transistors for Radiation Hardened Analog Applications",
                  authors: "<b>Gustavo Paz Platcheck</b><sup>1</sup>, Guilherme Schwanke Cardoso<sup>2</sup> and Tiago Roberto Balen<sup>1</sup>\
                  <br><i><sup>1</sup>UFRGS, Brazil and <sup>2</sup>IFSul, Brazil</i>",
                },
              ],
            },
            {
              hours: "11:15 - 12:00",
              title: "Keynote Talk",
              optionalTitle: "Cost-Efficient Reliability of Edge-AI Chip",
              authors: "Maksim Jenihhin, Taltech, Estonia",
              chair: "Hans-Joachim Wunderlich, University of Stuttgart, Germany",
              to: "program/keynotes",
            },
            {
              hours: "12:00 - 13:00",
              title: "McCluskey Doctoral Thesis Award (15 minutes of time slot - 12 + 3 Q&A)",
              talks: [
                {
                  title: "A Self-adaptive Resilient Method for Implementing and Managing the High-reliability Processing System",
                  authors: "<b>Junchao Chen</b>",
                },
                {
                  title: "Run-time Redundancy Management of Processor Functional Units for Mixed-Critical Scenarios",
                  authors: "<b>Raphael Segabinazzi Ferrerira</b>",
                },
                {
                  title: "The Design and Test of SAMPA: An ASIC for gaseous detector systems in high energy physics",
                  authors: "<b>Bruno Sanches</b>",
                },
                {
                  title: "Early Soft Error Reliability Assessment of CNNs Executing on Resource-constrained IoT Edge Devices (remote presentation)",
                  authors: "<b>Geancarlo Abich</b>",
                },
              ],
            },
            {
              hours: "12:00 - 13:00",
              title: "LATTTC Group Meeting (parallel session)",
            },
            {
              hours: "13:00 - 14:00",
              title: "Lunch",
            },
            {
              hours: "14:00 - 19:00",
              title: "Social Event",
            },
            {
              hours: "20:00 - 00:00",
              title: "Gala Dinner",
            },
          ],
        },
        {
          title: "Friday April 12th, 2024",
          sessions: [
            {
              hours: "09:00 - 09:30",
              title: "Invited Talk",
              optionalTitle: "Pros and Cons of Assertion Mining",
              authors: "Graziano Pravadelli, University of Verona, Italy",
              chair: "Régis Leveugle, Grenoble-INP/TIMA, France",
              to: "program/invited",
            },
            {
              hours: "09:30 - 10:30",
              title: "Session 5 \"EMI- and Radiation-Aware Testing",
              timeslots: "(Paper time slot of 15 minutes: 12 minutes + 3 minutes Q&A)",
              chair: "Fabian Luis Vargas, IHP GmbH, Germany",
              talks: [
                {
                  title: "Simulation-Based Analysis and Modeling of Generated Single Event Transient Pulse Width",
                  authors: "<b>Marko Andjelkovic</b><sup>1</sup> and Milos Krstic<sup>1,2</sup>\
                  <br><i><sup>1</sup>IHP GmbH, Germany and <sup>2</sup>University of Potsdam, Germany</i>",
                },
                {
                  title: "Heavy Ion-Induced Faults on Programmable UART Controllers Embedded into SRAM-Based FPGA",
                  authors: "<b>Victor O. Costa</b><sup>1</sup>, Fabio Benevenuti<sup>2</sup>, Renan Menezes<sup>1</sup>, Lidia Shibuya Sato<sup>1</sup>, Luís Loures<sup>1</sup>, Fernanda L. Kastensmidt<sup>2</sup>, Nemitala Added<sup>3</sup>, Saulo Alberton<sup>3</sup>, Vitor A. P. Aguiar<sup>3</sup> and Nilberto H. Medina<sup>3</sup>\
                  <br><i><sup>1</sup>ITA, Brazil, <sup>2</sup>UFRGS, Brazil and <sup>3</sup>USP, Brazil</i>",
                },
                {
                  title: "Harmonic Response of Ring Oscillators under Single ElectroMagnetic Pulsed Fault Injection",
                  authors: "<b>Sami El Amraoui</b>, Aghiles Douadi, Régis Leveugle and Paolo Maistri\
                  <br><i>TIMA Laboratory, France</i>",
                },
                {
                  title: "Cross-Section Estimation for Assessment of Circuit Susceptibility to Radiation",
                  authors: "<b>Clayton Farias</b>, Paulo Butzen and Tiago Balen\
                  <br><i>UFRGS, Brazil</i>",
                },
              ],
            },
            {
              hours: "10:30 - 11:00",
              title: "Coffee-break",
            },
            {
              hours: "11:00 - 11:45",
              title: "Keynote Talk",
              optionalTitle: "Incompatible: Test Quality and Fortuitous Detection",
              authors: "Shawn Blanton, Carnegie Mellon University, US",
              chair: "Graziano Pravadelli, University of Verona, Italy",
              to: "program/keynotes",
            },
            {
              hours: "11:45 - 12:15",
              title: "Embedded Tutorial",
              optionalTitle: "Access to On-chip DfT Instruments via Functional Ports",
              authors: "Erik Larson, Lund University, Sweden",
              chair: "Liviu Cristian Miclea, Technical University of Cluj-Napoca, Romania",
              to: "program/invited",
            },
            {
              hours: "12:15 - 14:00",
              title: "Lunch",
            },
            {
              hours: "14:00 - 15:00",
              title: "Special Session 2",
              optionalTitle: "Resiliency Approaches in Photonic, Spiking, and Artificial Neural Networks",
              organizer: "Ernesto Sanchez, Politecnico di Torino, Italy",
            },
            {
              hours: "15:00 - 15:30",
              title: "Coffee-break",
            },
            {
              hours: "15:30 - 16:00",
              title: "Industrial Talk",
              optionalTitle: "On-Chip Cross-Layer Infrastructure for Lifecycle Management of  Aero-Space Systems",
              authors: "Fabian Luis Vargas, IHP GmbH, Germany",
              chair: "Paolo Bernardi, Politecnico di Torino, Italy",
              to: "program/invited",
            },
            {
              hours: "16:00 - 16:45",
              title: "Session 6 \"Reliability Assessment and Test of ANNs",
              timeslots: "(Paper time slot of 15 minutes: 12 minutes + 3 minutes Q&A)",
              chair: "Annachiara Ruospo, Politecnico di Torino, Italy",
              talks: [
                {
                  title: "Fault Analysis for a MTJ-based Spiking Neural Network",
                  authors: "Leonardo Miceli<sup>1</sup>, Elena Ioana Vatajelu<sup>2</sup> and <b>Victor Champac<sup>1</sup></b>\
                  <br><i><sup>1</sup>INAOE, Mexico and <sup>2</sup>TIMA Laboratory, France</i>",
                },
                {
                  title: "Assessing the Reliability of Different Split Computing Neural Network Application",
                  authors: "<b>Giuseppe Esposito</b>, Juan-David Guerrero-Balaguera, Josie Esteban Rodriguez Condia, Marco Levorato and Matteo Sonza Reorda\
                  <br><i>Politecnico di Torino, Italy</i>",
                },
                {
                  title: "DeepER-HD: An Error Resilient HyperDimensional Computing Framework with DNN Front-End for Feature Selection",
                  authors: "Mohamed Mejri, Chandramouli Amarnath and <b>Abhijit Chatterjee</b>\
                  <br><i>Georgia Institute of Technology, USA</i>",
                },
              ],
            },
            {
              hours: "16:45 - 17:00",
              title: "Cadence - Computational Software for Intelligent System Design",
              authors: "Raphael Segabinazzi Ferreira, Cadence, Brazil",
            },
            {
              hours: "17:00 - 17:30",
              title: "LATS2024 Closing Session",
            },
          ],
        },
      ],
    }),
};
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-card {
  word-break: unset !important;
}
h4 {
  font-weight: unset;
}
</style>
